// extracted by mini-css-extract-plugin
export var textInput = "_e8-0";